module.exports = __webpack_public_path__ + "static/media/takeaway-icon.896b5635.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/takeaway-icon.jpg
// module id = 1898
// module chunks = 0